// import React, { useState, useRef, useEffect } from "react";
// import mobileverify from "../../Assets/img/mobile verification.png";
// import axios from "axios";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   Button,
// } from "@mui/material";
// import { MuiTelInput, matchIsValidTel } from 'mui-tel-input'
// import InfoToast from "../Utilities/InfoToast";
// import { useQuantityContext } from "../QuantityContext";

// const ActiveStep4 = ({ formData, setFormData, setActiveStep, activeStep }) => {
//   const { openSnackbar, handleFailure, handleInfo } = useQuantityContext();

//   const apiKey = process.env.REACT_APP_API_KEY
//   const headers = {
//     'x-api-key': apiKey,
//     'Content-Type': 'application/json',
//   };

//   const [verificationPageVisible, setVerificationPageVisible] = useState(false);
//   const [isVerifiedDialogOpen, setIsVerifiedDialogOpen] = useState(false);
//   const [phoneotpValues, setphoneOtpValues] = useState(["", "", "", ""]);
//   const phoneotpInputsRef = useRef([]);
//   const [ValidEmail, setValidEmail] = useState(false);
//   const [ValidNext, setValidNext] = useState(false);
//   const [isPhoneVerified, setIsPhoneVerified] = useState(false); // New state for verification status

//   useEffect(() => {
//     if (phoneotpInputsRef.current[0]) {
//       phoneotpInputsRef.current[0].focus();
//     }
//   }, []);

//   const [minutes, setMinutes] = useState(3);
//   const [seconds, setSeconds] = useState(0);

//   const resendOTP = async () => {
//     if (phoneNumber === "" || !matchIsValidTel(phoneNumber)) {
//       setIsPhoneNumberEmpty(true);
//       openSnackbar("Empty or Invalid Phone Number. Try Again.", "error");
//       return;
//     } else {
//       setIsPhoneNumberEmpty(false);
//     }

//     try {
//       setIsVisible(true);
//       openSnackbar("Sending OTP to your phone number...", "info", 3000);
//       const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/onboard/send-mobile-otp`, { mobileNumber: phoneNumber },
//         { headers: headers }
//       );
//       if (response.status === 200) {
//         setMinutes(0);
//         setSeconds(180);
//         setValidNext(false);
//         openSnackbar('OTP sent successfully to your Phone Number.', "success", 6000);
//         setFormData((prevFormData) => ({
//           ...prevFormData,
//           phoneNo: phoneNumber,
//         }));
//       }
//     } catch (error) {
//       console.error("Error sending otp:", error);
//     }
//   };

//   const handlePhoneInput = (index) => (e) => {
//     const { value } = e.target;

//     setphoneOtpValues((prevValues) => {
//       const newValues = [...prevValues];
//       newValues[index] = value.slice(0, 1);

//       if (value.length === e.target.maxLength && index < phoneotpInputsRef.current.length - 1) {
//         phoneotpInputsRef.current[index + 1].focus();
//       }

//       return newValues;
//     });
//   };

//   const handleKeyDown = (index) => (e) => {
//     if (e.key === 'Backspace') {
//       if (phoneotpValues[index] === '' && index > 0) {
//         phoneotpInputsRef.current[index - 1].focus();
//         setphoneOtpValues((prevValues) => {
//           const newValues = [...prevValues];
//           newValues[index - 1] = '';
//           return newValues;
//         });
//       }
//     }
//   };

//   const [phoneNumber, setPhoneNumber] = useState("+91");
//   const [showfirstScreen, setshowfirstScreen] = useState(true);
//   const [showSecondScreen, setshowSecondScreen] = useState(false);
//   const [showThirdScreen, setshowThirdScreen] = useState(false);
//   const [isPhoneNumberEmpty, setIsPhoneNumberEmpty] = useState(false);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     if (showSecondScreen) {
//       const interval = setInterval(() => {
//         if (minutes === 0 && seconds === 0) {
//           setphoneOtpValues(["", "", "", ""]);
//           clearInterval(interval);
//         } else {
//           if (seconds > 0) {
//             setSeconds(seconds - 1);
//           } else {
//             if (minutes > 0) {
//               setMinutes(minutes - 1);
//               setSeconds(59);
//             }
//           }
//         }
//       }, 1000);

//       return () => {
//         clearInterval(interval);
//       };
//     }
//   }, [showSecondScreen, seconds, minutes]);

//   const formatPhoneNumber = (phoneNumber) => {
//     const match = phoneNumber.match(/^(\+\d{1,3})\s?(.*)$/);
//     if (match) {
//       const countryCode = match[1];
//       const cleanedRestOfNumber = match[2].replace(/\s+/g, '');
//       return `${countryCode} ${cleanedRestOfNumber}`;
//     }
//     return phoneNumber;
//   };

//   const handlefirstClick = async () => {
//     if (phoneNumber === "" || !matchIsValidTel(phoneNumber)) {
//       setIsPhoneNumberEmpty(true);
//       openSnackbar("Empty or Invalid Phone Number. Try Again.", "error");
//       return;
//     } else {
//       setIsPhoneNumberEmpty(false);
//     }

//     if (!isPhoneNumberEmpty) {
//       openSnackbar("Sending OTP to Phone Number...", "info", 3000);
//       try {
//         setValidEmail(true);
//         const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/onboard/send-mobile-otp`, { mobileNumber: phoneNumber },
//           { headers: headers }
//         );

//         if (response.status === 226) {
//           openSnackbar("User already registered. Please Login.", "info", 8000);
//           setValidEmail(false);
//           return;
//         }
//         else if (response.status === 200) {
//           openSnackbar('OTP sent successfully to the Phone Number.', "success", 8000);
//           const cleanedPhoneNumber = formatPhoneNumber(phoneNumber)
//           setFormData((prevFormData) => ({
//             ...prevFormData,
//             phoneNo: cleanedPhoneNumber,
//           }));
//           setValidEmail(false);
//           setTimeout(() => {
//             setshowSecondScreen(true);
//             setshowfirstScreen(false);
//           }, 1500);
//         }
//       } catch (error) {
//         console.error("Error sending otp:", error);
//         openSnackbar("Failed to send OTP. Check the Phone Number or Try again later.", "error", 8000);
//         setValidEmail(false);
//       }
//     }
//   };

//   const handlesecondClick = async () => {
//     if (phoneNumber === "" || !matchIsValidTel(phoneNumber)) {
//       setIsPhoneNumberEmpty(true);
//       openSnackbar("Empty or Invalid Phone Number. Try Again.", "error");
//       return;
//     }

//     const otp = parseInt(phoneotpValues.join(""));
//     setValidNext(true);

//     try {
//       const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/verify-mobile-otp`,
//         { mobileNumber: phoneNumber, otp: otp },
//         { headers: headers }
//       );

//       // Successfully verified
//       if (response.status === 200) {
//         setIsPhoneVerified(true); // Set verification status to true
//         setIsVerifiedDialogOpen(true);
//         setshowThirdScreen(true);
//         setshowSecondScreen(false);
//         openSnackbar("Phone number verified successfully!", "success", 3000);

//         setFormData((prevFormData) => ({
//           ...prevFormData,
//           phoneNo: phoneNumber,
//           phoneVerified: true
//         }));

//         // Removed the scroll trigger
//       }
//     } catch (error) {
//       console.error("Error verifying otp:", error);
//       setValidNext(false);
//       if (error.response) {
//         const { message } = error.response.data;
//         if (message === "Incorrect OTP") {
//           console.log("Incorrect OTP Response:", error.response);
//           openSnackbar("Incorrect OTP! Please Try Again.", "error");
//           return;
//         }
//         if (message === "Invalid OTP") {
//           console.log("Invalid OTP Response:", error.response);
//           openSnackbar("Invalid OTP! Please Try Again.", "error");
//           return;
//         }
//       } else {
//         console.error('Error verifying email:', error);
//         handleFailure('Error verifying Phone Number. Please try again later.');
//       }
//     }
//   };

//   const handlePhoneChange = (value) => {
//     if (isPhoneVerified) return; // Don't allow changes if verified
//     setValidEmail(false);
//     setPhoneNumber(value);
//     setIsPhoneNumberEmpty(false);
//   };

//   console.log("ACTIVE STEP IN THE Mobile verification", activeStep, formData);

//   const handleContinue2 = () => {
//     setIsVerifiedDialogOpen(false);
//     if (formData?.profession === "Personal") {
//       setActiveStep(5);
//     } else {
//       setActiveStep((prevActiveStep) => prevActiveStep + 1);
//     }
//   };

//   const handleNext = async () => {
//     // This function is no longer needed but kept for compatibility
//   }

//   const handleCloseVerifiedDialog = () => {
//     setIsVerifiedDialogOpen(false);
//     setVerificationPageVisible(false);
//   };

//   const [value, setValue] = React.useState('')

//   const handleChange = (newValue) => {
//     setValue(newValue)
//   }

//   useEffect(() => {
//     const timeout = setTimeout(() => {
//       setIsVisible(false);
//     }, 30000);
//     return () => clearTimeout(timeout);
//   }, []);

//   const shouldBlink = seconds < 20 && minutes === 0 && seconds !== 0;
//   const blinkClass = shouldBlink ? "otp-blinking" : "";

//   const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
//   const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

//   return (
//     <>
//       {showfirstScreen && (
//         <>
//           <div className="page-title-wrapper">
//             <h2 className="onboard-slide-title-2">Add Phone Number</h2>

//             <p className="sub-title-phone" style={{ 
//               fontSize: '16px', 
//               lineHeight: '1.6',
//               color: '#475569',
//               marginBottom: '8px'
//             }}>
//               Please add your personal phone number. We'll send a verification OTP to this number.
//             </p>
//             <p className="sub-title-phone" style={{ 
//               fontSize: '14px', 
//               color: '#64748b',
//               marginBottom: '20px'
//             }}>
//               Make sure to use a valid phone number that you have access to.
//             </p>
//           </div>

//           <div className="mx-auto">
//             <MuiTelInput
//               name="phone"
//               value={phoneNumber}
//               onChange={handlePhoneChange}
//               defaultCountry={'in'}
//               MenuProps={PhoneInputMenuProps}
//               required
//               className={` text-field-outline input-text ph-no-input ${isPhoneNumberEmpty ? "phone-input-error" : ""}`}
//               fullWidth
//               error={isPhoneNumberEmpty}
//               disabled={isPhoneVerified}
//               sx={{
//                 '& .MuiOutlinedInput-root': {
//                   borderRadius: '8px',
//                   backgroundColor: isPhoneVerified ? '#f5f5f5' : '#ffffff',
//                   '& fieldset': {
//                     borderColor: isPhoneVerified ? '#4caf50' : '#d0d5dd',
//                   },
//                   '&:hover fieldset': {
//                     borderColor: isPhoneVerified ? '#4caf50' : '#0044C6',
//                   },
//                   '&.Mui-focused fieldset': {
//                     borderColor: isPhoneVerified ? '#4caf50' : '#0044C6',
//                   },
//                 },
//                 '& .MuiInputLabel-root': {
//                   color: isPhoneVerified ? '#4caf50' : '#344054',
//                   '&.Mui-focused': {
//                     color: isPhoneVerified ? '#4caf50' : '#0044C6',
//                   },
//                 },
//                 '& .MuiInputBase-input': {
//                   color: '#1a1a1a',
//                 },
//               }} />

//             <div className="pt-2 next-button-container">
//               <Button
//                 className={`next-btn primary-contained`}
//                 variant="contained"
//                 onClick={handlefirstClick}
//                 disabled={(phoneNumber.length <= 3 || phoneNumber.length === 4) || ValidEmail || isPhoneVerified}
//                 sx={{
//                   textTransform: 'uppercase',
//                   fontWeight: 600,
//                   backgroundColor: '#0044C6',
//                   color: '#ffffff',
//                   padding: '10px 40px',
//                   borderRadius: '8px',
//                   '&:hover': {
//                     backgroundColor: '#003399',
//                   },
//                   '&.Mui-disabled': {
//                     backgroundColor: '#e0e0e0',
//                     color: '#999999'
//                   }
//                 }}>
//                 Next
//               </Button>
//             </div>
//           </div>
//         </>
//       )}

//       {showSecondScreen && (
//         <>
//           <React.Fragment>
//             <div className="page-title-wrapper">
//               <h2 className="onboard-slide-title-2">Please Verify your Mobile Number</h2>
//               <p className="sub-title-phone">
//                 Check your device for a verification SMS.
//               </p>
//             </div>

//             <div className="mx-auto">
//               <MuiTelInput
//                 name="phone"
//                 value={phoneNumber}
//                 onChange={handlePhoneChange}
//                 required
//                 className={`text-field-outline input-text ${isPhoneNumberEmpty ? "phone-input-error" : ""}`}
//                 defaultCountry={'in'}
//                 fullWidth
//                 error={isPhoneNumberEmpty}
//                 disabled={isPhoneVerified}
//                 sx={{
//                   '& .MuiOutlinedInput-root': {
//                     borderRadius: '8px',
//                     backgroundColor: isPhoneVerified ? '#f5f5f5' : '#ffffff',
//                     '& fieldset': {
//                       borderColor: isPhoneVerified ? '#4caf50' : '#d0d5dd',
//                     },
//                     '&:hover fieldset': {
//                       borderColor: isPhoneVerified ? '#4caf50' : '#0044C6',
//                     },
//                     '&.Mui-focused fieldset': {
//                       borderColor: isPhoneVerified ? '#4caf50' : '#0044C6',
//                     },
//                   },
//                   '& .MuiInputLabel-root': {
//                     color: isPhoneVerified ? '#4caf50' : '#344054',
//                     '&.Mui-focused': {
//                       color: isPhoneVerified ? '#4caf50' : '#0044C6',
//                     },
//                   },
//                   '& .MuiInputBase-input': {
//                     color: '#1a1a1a',
//                   },
//                 }} />

//               {/* Show verification status and verified badge */}
//               {isPhoneVerified ? (
//                 <div style={{
//                   backgroundColor: '#e8f5e9',
//                   padding: '12px 16px',
//                   borderRadius: '8px',
//                   marginTop: '12px',
//                   marginBottom: '20px',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   gap: '10px',
//                   border: '1px solid #4caf50'
//                 }}>
//                   <span style={{ color: '#2e7d32', fontSize: '20px', fontWeight: 'bold' }}>✓</span>
//                   <span style={{ color: '#1b5e20', fontSize: '15px', fontWeight: 600 }}>
//                     Phone Number Verified Successfully!
//                   </span>
//                 </div>
//               ) : (
//                 <>
//                   <div className="pt-25"></div>

//                   <div className="otp-input-wrapper">
//                     {[1, 2, 3, 4].map((_, index) => (
//                       <input
//                         key={index}
//                         type="text"
//                         className="otp-input"
//                         maxLength="1"
//                         id={`otp${index + 1}`}
//                         ref={(el) => (phoneotpInputsRef.current[index] = el)}
//                         value={phoneotpValues[index]}
//                         onChange={handlePhoneInput(index)}
//                         disabled={minutes === 0 && seconds === 0 || isPhoneVerified}
//                         onKeyDown={handleKeyDown(index)}
//                         autoFocus={index === 0}
//                       />
//                     ))}
//                   </div>

//                   <div className="justify-content-space-bw-login mt-20">
//                     <div className="resent-otp">
//                       Remaining Time:
//                       <span className={`time-unit ${blinkClass}`}>{formattedMinutes}</span>:
//                       <span className={`time-unit ${blinkClass}`}>{formattedSeconds}</span>
//                     </div>

//                     <div className="next-button-container gap-3 pt-2">
//                       <Button
//                         variant="contained"
//                         className={`next-btn primary-contained`}
//                         onClick={handlesecondClick}
//                         disabled={phoneotpValues.some((value) => !value) || ValidNext || isPhoneVerified}
//                         sx={{
//                           textTransform: 'uppercase',
//                           fontWeight: 600,
//                           backgroundColor: '#0044C6',
//                           color: '#ffffff',
//                           padding: '10px 40px',
//                           borderRadius: '8px',
//                           '&:hover': {
//                             backgroundColor: '#003399',
//                           },
//                           '&.Mui-disabled': {
//                             backgroundColor: '#e0e0e0',
//                             color: '#999999'
//                           }
//                         }}>
//                         Verify
//                       </Button>
//                     </div>
//                   </div>
//                   <div className="resent-otp-design mt-20">
//                     Didn't get the code? <Button sx={{ color: "#0044C6" }} onClick={resendOTP}>RESEND</Button>
//                   </div>
//                 </>
//               )}

//               {/* Continue button - shown when verified */}
//               {isPhoneVerified && (
//                 <div className="pt-2 next-button-container" style={{ marginTop: '20px' }}>
//                   <Button
//                     variant="contained"
//                     className={`next-btn primary-contained`}
//                     onClick={handleContinue2}
//                     sx={{
//                       textTransform: 'uppercase',
//                       fontWeight: 600,
//                       backgroundColor: '#0044C6',
//                       color: '#ffffff',
//                       padding: '10px 40px',
//                       borderRadius: '8px',
//                       '&:hover': {
//                         backgroundColor: '#003399',
//                       }
//                     }}>
//                     Continue
//                   </Button>
//                 </div>
//               )}
//             </div>
//           </React.Fragment>
//         </>
//       )}

//       {showThirdScreen && (
//         <>
//           <React.Fragment>
//             <h2 className="onboard-slide-title-2">Please Verify your Mobile Number</h2>
//             <p className="sub-title-phone">
//               Will send you otp to below mentioned Number
//             </p>

//             <MuiTelInput 
//               name="phone" 
//               value={phoneNumber} 
//               required 
//               className={isPhoneNumberEmpty ? "phone-input-error" : ""} 
//               defaultCountry={'in'}
//               disabled={true}
//               sx={{
//                 '& .MuiOutlinedInput-root': {
//                   borderRadius: '8px',
//                   backgroundColor: '#f5f5f5',
//                   '& fieldset': {
//                     borderColor: '#4caf50',
//                   },
//                 },
//                 '& .MuiInputLabel-root': {
//                   color: '#4caf50',
//                 },
//                 '& .MuiInputBase-input': {
//                   color: '#1a1a1a',
//                 },
//               }} />

//             <div className="pt-2 next-button-container">
//               <Button
//                 variant="contained"
//                 className={`next-btn primary-contained`}
//                 onClick={handleContinue2}
//                 sx={{
//                   textTransform: 'uppercase',
//                   fontWeight: 600,
//                   backgroundColor: '#0044C6',
//                   color: '#ffffff',
//                   padding: '10px 40px',
//                   borderRadius: '8px',
//                   '&:hover': {
//                     backgroundColor: '#003399',
//                   }
//                 }}>
//                 Continue
//               </Button>
//             </div>

//             <Dialog
//               open={isVerifiedDialogOpen}
//               onClose={handleCloseVerifiedDialog}
//               aria-labelledby="alert-dialog-title"
//               aria-describedby="alert-dialog-description"
//             >
//               <DialogContent className="dialogContainer email-dialog">
//                 <img
//                   src={mobileverify}
//                   alt="Verification"
//                   className="dialogImage"
//                 />
//                 <DialogTitle id="alert-dialog-title">
//                   Mobile Number Verified
//                 </DialogTitle>
//                 <DialogContentText className="dialogText">
//                   Your account is secure! Mobile verification is complete.
//                 </DialogContentText>
//                 <Button
//                   onClick={handleContinue2}
//                   variant="contained"
//                   className="continueButton primary-button"
//                   sx={{
//                     backgroundColor: '#0044C6',
//                     color: '#ffffff',
//                     '&:hover': {
//                       backgroundColor: '#003399',
//                     }
//                   }}
//                 >
//                   Continue
//                 </Button>
//               </DialogContent>
//             </Dialog>
//           </React.Fragment>
//         </>
//       )}
//     </>
//   );
// };

// export default ActiveStep4;

// export const PhoneInputMenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: "calc(50% - 96px)",
//       marginTop: "20px",
//     }
//   }
// }


import React, { useState, useRef, useEffect } from "react";
import mobileverify from "../../Assets/img/mobile verification.png";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
} from "@mui/material";
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input'
import InfoToast from "../Utilities/InfoToast";
import { useQuantityContext } from "../QuantityContext";

const ActiveStep4 = ({ formData, setFormData, setActiveStep, activeStep, onVerificationComplete, verificationStatus, isSignup }) => {
  const { openSnackbar, handleFailure, handleInfo } = useQuantityContext();

  const apiKey = process.env.REACT_APP_API_KEY
  const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
  };

  const [verificationPageVisible, setVerificationPageVisible] = useState(false);
  const [isVerifiedDialogOpen, setIsVerifiedDialogOpen] = useState(false);
  const [phoneotpValues, setphoneOtpValues] = useState(["", "", "", ""]);
  const phoneotpInputsRef = useRef([]);
  const [ValidEmail, setValidEmail] = useState(false);
  const [ValidNext, setValidNext] = useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);

  useEffect(() => {
    if (phoneotpInputsRef.current[0]) {
      phoneotpInputsRef.current[0].focus();
    }
  }, []);

  const [minutes, setMinutes] = useState(3);
  const [seconds, setSeconds] = useState(0);

  const resendOTP = async () => {
    if (phoneNumber === "" || !matchIsValidTel(phoneNumber)) {
      setIsPhoneNumberEmpty(true);
      openSnackbar("Empty or Invalid Phone Number. Try Again.", "error");
      return;
    } else {
      setIsPhoneNumberEmpty(false);
    }

    try {
      setIsVisible(true);
      openSnackbar("Sending OTP to your phone number...", "info", 3000);
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/onboard/send-mobile-otp`, { mobileNumber: phoneNumber },
        { headers: headers }
      );
      if (response.status === 200) {
        setMinutes(0);
        setSeconds(180);
        setValidNext(false);
        openSnackbar('OTP sent successfully to your Phone Number.', "success", 6000);
        setFormData((prevFormData) => ({
          ...prevFormData,
          phoneNo: phoneNumber,
        }));
      }
    } catch (error) {
      console.error("Error sending otp:", error);
    }
  };

  const handlePhoneInput = (index) => (e) => {
    const { value } = e.target;

    setphoneOtpValues((prevValues) => {
      const newValues = [...prevValues];
      newValues[index] = value.slice(0, 1);

      if (value.length === e.target.maxLength && index < phoneotpInputsRef.current.length - 1) {
        phoneotpInputsRef.current[index + 1].focus();
      }

      return newValues;
    });
  };

  const handleKeyDown = (index) => (e) => {
    if (e.key === 'Backspace') {
      if (phoneotpValues[index] === '' && index > 0) {
        phoneotpInputsRef.current[index - 1].focus();
        setphoneOtpValues((prevValues) => {
          const newValues = [...prevValues];
          newValues[index - 1] = '';
          return newValues;
        });
      }
    }
  };

  const [phoneNumber, setPhoneNumber] = useState("+91");
  const [showfirstScreen, setshowfirstScreen] = useState(true);
  const [showSecondScreen, setshowSecondScreen] = useState(false);
  const [showThirdScreen, setshowThirdScreen] = useState(false);
  const [isPhoneNumberEmpty, setIsPhoneNumberEmpty] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (showSecondScreen) {
      const interval = setInterval(() => {
        if (minutes === 0 && seconds === 0) {
          setphoneOtpValues(["", "", "", ""]);
          clearInterval(interval);
        } else {
          if (seconds > 0) {
            setSeconds(seconds - 1);
          } else {
            if (minutes > 0) {
              setMinutes(minutes - 1);
              setSeconds(59);
            }
          }
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [showSecondScreen, seconds, minutes]);

  const formatPhoneNumber = (phoneNumber) => {
    const match = phoneNumber.match(/^(\+\d{1,3})\s?(.*)$/);
    if (match) {
      const countryCode = match[1];
      const cleanedRestOfNumber = match[2].replace(/\s+/g, '');
      return `${countryCode} ${cleanedRestOfNumber}`;
    }
    return phoneNumber;
  };

  const handlefirstClick = async () => {
    if (phoneNumber === "" || !matchIsValidTel(phoneNumber)) {
      setIsPhoneNumberEmpty(true);
      openSnackbar("Empty or Invalid Phone Number. Try Again.", "error");
      return;
    } else {
      setIsPhoneNumberEmpty(false);
    }

    if (!isPhoneNumberEmpty) {
      openSnackbar("Sending OTP to Phone Number...", "info", 3000);
      try {
        setValidEmail(true);
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/onboard/send-mobile-otp`, { mobileNumber: phoneNumber },
          { headers: headers }
        );

        if (response.status === 226) {
          openSnackbar("User already registered. Please Login.", "info", 8000);
          setValidEmail(false);
          return;
        }
        else if (response.status === 200) {
          openSnackbar('OTP sent successfully to the Phone Number.', "success", 8000);
          const cleanedPhoneNumber = formatPhoneNumber(phoneNumber)
          setFormData((prevFormData) => ({
            ...prevFormData,
            phoneNo: cleanedPhoneNumber,
          }));
          setValidEmail(false);
          setTimeout(() => {
            setshowSecondScreen(true);
            setshowfirstScreen(false);
          }, 1500);
        }
      } catch (error) {
        console.error("Error sending otp:", error);
        openSnackbar("Failed to send OTP. Check the Phone Number or Try again later.", "error", 8000);
        setValidEmail(false);
      }
    }
  };

  const handlesecondClick = async () => {
    if (phoneNumber === "" || !matchIsValidTel(phoneNumber)) {
      setIsPhoneNumberEmpty(true);
      openSnackbar("Empty or Invalid Phone Number. Try Again.", "error");
      return;
    }

    const otp = parseInt(phoneotpValues.join(""));
    setValidNext(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/verify-mobile-otp`,
        { mobileNumber: phoneNumber, otp: otp },
        { headers: headers }
      );

      if (response.status === 200) {
        setIsPhoneVerified(true);
        setIsVerifiedDialogOpen(true);
        setshowThirdScreen(true);
        setshowSecondScreen(false);
        openSnackbar("Phone number verified successfully!", "success", 3000);

        // 🔥 ADD THIS: Call the verification complete callback
        if (onVerificationComplete) {
          onVerificationComplete(true);
        }

        setFormData((prevFormData) => ({
          ...prevFormData,
          phoneNo: phoneNumber,
          phoneVerified: true
        }));
      }
    } catch (error) {
      console.error("Error verifying otp:", error);
      setValidNext(false);
      if (error.response) {
        const { message } = error.response.data;
        if (message === "Incorrect OTP") {
          console.log("Incorrect OTP Response:", error.response);
          openSnackbar("Incorrect OTP! Please Try Again.", "error");
          return;
        }
        if (message === "Invalid OTP") {
          console.log("Invalid OTP Response:", error.response);
          openSnackbar("Invalid OTP! Please Try Again.", "error");
          return;
        }
      } else {
        console.error('Error verifying email:', error);
        handleFailure('Error verifying Phone Number. Please try again later.');
      }
    }
  };

  const handlePhoneChange = (value) => {
    if (isPhoneVerified || verificationStatus?.phoneVerified) return;
    setValidEmail(false);
    setPhoneNumber(value);
    setIsPhoneNumberEmpty(false);
  };

  console.log("ACTIVE STEP IN THE Mobile verification", activeStep, formData);

  const handleContinue2 = () => {
    setIsVerifiedDialogOpen(false);
    if (isSignup) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
    else {
      if (formData?.profession === "Personal") {
        setActiveStep(5);
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    }

  };

  const handleNext = async () => {
    // This function is no longer needed but kept for compatibility
  }

  const handleCloseVerifiedDialog = () => {
    setIsVerifiedDialogOpen(false);
    setVerificationPageVisible(false);
  };

  const [value, setValue] = React.useState('')

  const handleChange = (newValue) => {
    setValue(newValue)
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(false);
    }, 30000);
    return () => clearTimeout(timeout);
  }, []);

  const shouldBlink = seconds < 20 && minutes === 0 && seconds !== 0;
  const blinkClass = shouldBlink ? "otp-blinking" : "";

  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return (
    <>
      {showfirstScreen && (
        <>
          <div className="page-title-wrapper">
            <h2 className="onboard-slide-title-2">Add Phone Number</h2>

            <p className="sub-title-phone" style={{
              fontSize: '16px',
              lineHeight: '1.6',
              color: '#475569',
              marginBottom: '8px'
            }}>
              Please add your personal phone number. We'll send a verification OTP to this number.
            </p>
            <p className="sub-title-phone" style={{
              fontSize: '14px',
              color: '#64748b',
              marginBottom: '20px'
            }}>
              Make sure to use a valid phone number that you have access to.
            </p>
          </div>

          <div className="mx-auto">
            <MuiTelInput
              name="phone"
              value={phoneNumber}
              onChange={handlePhoneChange}
              defaultCountry={'in'}
              MenuProps={PhoneInputMenuProps}
              required
              className={` text-field-outline input-text ph-no-input ${isPhoneNumberEmpty ? "phone-input-error" : ""}`}
              fullWidth
              error={isPhoneNumberEmpty}
              disabled={isPhoneVerified || verificationStatus?.phoneVerified}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px',
                  backgroundColor: (isPhoneVerified || verificationStatus?.phoneVerified) ? '#f5f5f5' : '#ffffff',
                  '& fieldset': {
                    borderColor: (isPhoneVerified || verificationStatus?.phoneVerified) ? '#4caf50' : '#d0d5dd',
                  },
                  '&:hover fieldset': {
                    borderColor: (isPhoneVerified || verificationStatus?.phoneVerified) ? '#4caf50' : '#0044C6',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: (isPhoneVerified || verificationStatus?.phoneVerified) ? '#4caf50' : '#0044C6',
                  },
                },
                '& .MuiInputLabel-root': {
                  color: (isPhoneVerified || verificationStatus?.phoneVerified) ? '#4caf50' : '#344054',
                  '&.Mui-focused': {
                    color: (isPhoneVerified || verificationStatus?.phoneVerified) ? '#4caf50' : '#0044C6',
                  },
                },
                '& .MuiInputBase-input': {
                  color: '#1a1a1a',
                },
              }} />

            <div className="pt-2 next-button-container">
              <Button
                className={`next-btn primary-contained`}
                variant="contained"
                onClick={handlefirstClick}
                disabled={(phoneNumber.length <= 3 || phoneNumber.length === 4) || ValidEmail || isPhoneVerified || verificationStatus?.phoneVerified}
                sx={{
                  textTransform: 'uppercase',
                  fontWeight: 600,
                  backgroundColor: '#0044C6',
                  color: '#ffffff',
                  padding: '10px 40px',
                  borderRadius: '8px',
                  '&:hover': {
                    backgroundColor: '#003399',
                  },
                  '&.Mui-disabled': {
                    backgroundColor: '#e0e0e0',
                    color: '#999999'
                  }
                }}>
                Next
              </Button>
            </div>
          </div>
        </>
      )}

      {showSecondScreen && (
        <>
          <React.Fragment>
            <div className="page-title-wrapper">
              <h2 className="onboard-slide-title-2">Please Verify your Mobile Number</h2>
              <p className="sub-title-phone">
                Check your device for a verification SMS.
              </p>
            </div>

            <div className="mx-auto">
              <MuiTelInput
                name="phone"
                value={phoneNumber}
                onChange={handlePhoneChange}
                required
                className={`text-field-outline input-text ${isPhoneNumberEmpty ? "phone-input-error" : ""}`}
                defaultCountry={'in'}
                fullWidth
                error={isPhoneNumberEmpty}
                disabled={isPhoneVerified || verificationStatus?.phoneVerified}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: (isPhoneVerified || verificationStatus?.phoneVerified) ? '#f5f5f5' : '#ffffff',
                    '& fieldset': {
                      borderColor: (isPhoneVerified || verificationStatus?.phoneVerified) ? '#4caf50' : '#d0d5dd',
                    },
                    '&:hover fieldset': {
                      borderColor: (isPhoneVerified || verificationStatus?.phoneVerified) ? '#4caf50' : '#0044C6',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: (isPhoneVerified || verificationStatus?.phoneVerified) ? '#4caf50' : '#0044C6',
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color: (isPhoneVerified || verificationStatus?.phoneVerified) ? '#4caf50' : '#344054',
                    '&.Mui-focused': {
                      color: (isPhoneVerified || verificationStatus?.phoneVerified) ? '#4caf50' : '#0044C6',
                    },
                  },
                  '& .MuiInputBase-input': {
                    color: '#1a1a1a',
                  },
                }} />

              {/* Show verification status and verified badge */}
              {(isPhoneVerified || verificationStatus?.phoneVerified) ? (
                <div style={{
                  backgroundColor: '#e8f5e9',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  marginTop: '12px',
                  marginBottom: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  border: '1px solid #4caf50'
                }}>
                  <span style={{ color: '#2e7d32', fontSize: '20px', fontWeight: 'bold' }}>✓</span>
                  <span style={{ color: '#1b5e20', fontSize: '15px', fontWeight: 600 }}>
                    Phone Number Verified Successfully!
                  </span>
                </div>
              ) : (
                <>
                  <div className="pt-25"></div>

                  <div className="otp-input-wrapper">
                    {[1, 2, 3, 4].map((_, index) => (
                      <input
                        key={index}
                        type="text"
                        className="otp-input"
                        maxLength="1"
                        id={`otp${index + 1}`}
                        ref={(el) => (phoneotpInputsRef.current[index] = el)}
                        value={phoneotpValues[index]}
                        onChange={handlePhoneInput(index)}
                        disabled={minutes === 0 && seconds === 0 || isPhoneVerified || verificationStatus?.phoneVerified}
                        onKeyDown={handleKeyDown(index)}
                        autoFocus={index === 0}
                      />
                    ))}
                  </div>

                  <div className="justify-content-space-bw-login mt-20">
                    <div className="resent-otp">
                      Remaining Time:
                      <span className={`time-unit ${blinkClass}`}>{formattedMinutes}</span>:
                      <span className={`time-unit ${blinkClass}`}>{formattedSeconds}</span>
                    </div>

                    <div className="next-button-container gap-3 pt-2">
                      <Button
                        variant="contained"
                        className={`next-btn primary-contained`}
                        onClick={handlesecondClick}
                        disabled={phoneotpValues.some((value) => !value) || ValidNext || isPhoneVerified || verificationStatus?.phoneVerified}
                        sx={{
                          textTransform: 'uppercase',
                          fontWeight: 600,
                          backgroundColor: '#0044C6',
                          color: '#ffffff',
                          padding: '10px 40px',
                          borderRadius: '8px',
                          '&:hover': {
                            backgroundColor: '#003399',
                          },
                          '&.Mui-disabled': {
                            backgroundColor: '#e0e0e0',
                            color: '#999999'
                          }
                        }}>
                        Verify
                      </Button>
                    </div>
                  </div>
                  <div className="resent-otp-design mt-20">
                    Didn't get the code? <Button sx={{ color: "#0044C6" }} onClick={resendOTP}>RESEND</Button>
                  </div>
                </>
              )}

              {/* Continue button - shown when verified */}
              {(isPhoneVerified || verificationStatus?.phoneVerified) && (
                <div className="pt-2 next-button-container" style={{ marginTop: '20px' }}>
                  <Button
                    variant="contained"
                    className={`next-btn primary-contained`}
                    onClick={handleContinue2}
                    sx={{
                      textTransform: 'uppercase',
                      fontWeight: 600,
                      backgroundColor: '#0044C6',
                      color: '#ffffff',
                      padding: '10px 40px',
                      borderRadius: '8px',
                      '&:hover': {
                        backgroundColor: '#003399',
                      }
                    }}>
                    Continue
                  </Button>
                </div>
              )}
            </div>
          </React.Fragment>
        </>
      )}

      {showThirdScreen && (
        <>
          <React.Fragment>
            <h2 className="onboard-slide-title-2">Please Verify your Mobile Number</h2>
            <p className="sub-title-phone">
              Will send you otp to below mentioned Number
            </p>

            <MuiTelInput
              name="phone"
              value={phoneNumber}
              required
              className={isPhoneNumberEmpty ? "phone-input-error" : ""}
              defaultCountry={'in'}
              disabled={true}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px',
                  backgroundColor: '#f5f5f5',
                  '& fieldset': {
                    borderColor: '#4caf50',
                  },
                },
                '& .MuiInputLabel-root': {
                  color: '#4caf50',
                },
                '& .MuiInputBase-input': {
                  color: '#1a1a1a',
                },
              }} />

            <div className="pt-2 next-button-container">
              <Button
                variant="contained"
                className={`next-btn primary-contained`}
                onClick={handleContinue2}
                sx={{
                  textTransform: 'uppercase',
                  fontWeight: 600,
                  backgroundColor: '#0044C6',
                  color: '#ffffff',
                  padding: '10px 40px',
                  borderRadius: '8px',
                  '&:hover': {
                    backgroundColor: '#003399',
                  }
                }}>
                Continue
              </Button>
            </div>

            <Dialog
              open={isVerifiedDialogOpen}
              onClose={handleCloseVerifiedDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent className="dialogContainer email-dialog">
                <img
                  src={mobileverify}
                  alt="Verification"
                  className="dialogImage"
                />
                <DialogTitle id="alert-dialog-title">
                  Mobile Number Verified
                </DialogTitle>
                <DialogContentText className="dialogText">
                  Your account is secure! Mobile verification is complete.
                </DialogContentText>
                <Button
                  onClick={handleContinue2}
                  variant="contained"
                  className="continueButton primary-button"
                  sx={{
                    backgroundColor: '#0044C6',
                    color: '#ffffff',
                    '&:hover': {
                      backgroundColor: '#003399',
                    }
                  }}
                >
                  Continue
                </Button>
              </DialogContent>
            </Dialog>
          </React.Fragment>
        </>
      )}
    </>
  );
};

export default ActiveStep4;

export const PhoneInputMenuProps = {
  PaperProps: {
    style: {
      maxHeight: "calc(50% - 96px)",
      marginTop: "20px",
    }
  }
}



// import React, { useState, useRef, useEffect } from "react";
// import mobileverify from "../../Assets/img/mobile verification.png";
// import axios from "axios"; // for sending data to Backend
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   // DialogActions,
//   Button,
// } from "@mui/material";
// import { MuiTelInput, matchIsValidTel } from 'mui-tel-input'
// import InfoToast from "../Utilities/InfoToast";
// import { useQuantityContext } from "../QuantityContext";
// // import icon from '../../Assets/img/warning-icon.png'

// const ActiveStep4 = ({ formData, setFormData, setActiveStep, activeStep }) => {
//   const { openSnackbar, handleFailure, handleInfo, } = useQuantityContext();

//   const apiKey = process.env.REACT_APP_API_KEY
//   const headers = {
//     'x-api-key': apiKey,
//     'Content-Type': 'application/json',
//     // "ngrok-skip-browser-warning": "69420"
//   };

//   const [verificationPageVisible, setVerificationPageVisible] = useState(false);
//   const [isVerifiedDialogOpen, setIsVerifiedDialogOpen] = useState(true);
//   const [phoneotpValues, setphoneOtpValues] = useState(["", "", "", ""]);
//   // Concatenate the OTP values and convert them to a number
//   const phoneotpInputsRef = useRef([]);
//   const [ValidEmail, setValidEmail] = useState(false);
//   const [ValidNext, setValidNext] = useState(false);


//   // console.log("steps", steps, "activeStep", activeStep);
//   useEffect(() => {
//     if (phoneotpInputsRef.current[0]) {
//       phoneotpInputsRef.current[0].focus();
//     }
//   }, []);

//   const [minutes, setMinutes] = useState(3);
//   const [seconds, setSeconds] = useState(0); // Change initial seconds value to 0

//   const resendOTP = async () => {
//     if (phoneNumber === "" || !matchIsValidTel(phoneNumber)) {
//       setIsPhoneNumberEmpty(true);
//       openSnackbar("Empty or Invalid Phone Number. Try Again.", "error");
//       return;
//     } else {
//       setIsPhoneNumberEmpty(false);
//     }

//     try {
//       setIsVisible(true);
//       openSnackbar("Sending OTP to your phone number...", "info", 3000);
//       const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/onboard/send-mobile-otp`, { mobileNumber: phoneNumber },
//         { headers: headers }
//       );
//       // console.log(response.data.message); // Log response message
//       if (response.status === 200) {
//         setMinutes(0);
//         setSeconds(180);
//         setValidNext(false);
//         openSnackbar('OTP sent successfully to your Phone Number.', "success", 6000);
//         setFormData((prevFormData) => ({
//           ...prevFormData,
//           phoneNo: phoneNumber,
//         }));
//       }
//     } catch (error) {
//       console.error("Error sending otp:", error);
//     }
//   };

//   const handlePhoneInput = (index) => (e) => {
//     const { value } = e.target;

//     setphoneOtpValues((prevValues) => {
//       const newValues = [...prevValues];
//       newValues[index] = value.slice(0, 1);

//       if (value.length === e.target.maxLength && index < phoneotpInputsRef.current.length - 1) {
//         phoneotpInputsRef.current[index + 1].focus();
//       }

//       return newValues;
//     });
//   };

//   const handleKeyDown = (index) => (e) => {
//     if (e.key === 'Backspace') {
//       if (phoneotpValues[index] === '' && index > 0) {
//         phoneotpInputsRef.current[index - 1].focus();
//         setphoneOtpValues((prevValues) => {
//           const newValues = [...prevValues];
//           newValues[index - 1] = '';
//           return newValues;
//         });
//       }
//     }
//   };

//   const [phoneNumber, setPhoneNumber] = useState("+91");
//   const [showfirstScreen, setshowfirstScreen] = useState(true);
//   const [showSecondScreen, setshowSecondScreen] = useState(false);
//   const [showThirdScreen, setshowThirdScreen] = useState(false);
//   const [isPhoneNumberEmpty, setIsPhoneNumberEmpty] = useState(false);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {

//     if (showSecondScreen) {
//       const interval = setInterval(() => {
//         if (minutes === 0 && seconds === 0) {
//           setphoneOtpValues(["", "", "", ""]);
//           clearInterval(interval);

//         } else {
//           // Decrease seconds if greater than 0
//           if (seconds > 0) {
//             setSeconds(seconds - 1);
//           } else {
//             if (minutes > 0) {
//               setMinutes(minutes - 1);
//               setSeconds(59); // Reset seconds to 59 when minutes decrease
//             }
//           }
//         }
//       }, 1000);

//       return () => {
//         clearInterval(interval);
//       };
//     }
//   }, [showSecondScreen, seconds, minutes]);

//   const formatPhoneNumber = (phoneNumber) => {
//     // Match the country code (1 to 3 digits) and the rest of the number
//     const match = phoneNumber.match(/^(\+\d{1,3})\s?(.*)$/);
//     if (match) {
//       // Extract and clean the rest of the number
//       const countryCode = match[1];
//       const cleanedRestOfNumber = match[2].replace(/\s+/g, '');
//       return `${countryCode} ${cleanedRestOfNumber}`;
//     }
//     // Return the original phoneNumber if it doesn't match the expected format
//     return phoneNumber;
//   };

//   const handlefirstClick = async () => {

//     if (phoneNumber === "" || !matchIsValidTel(phoneNumber)) {
//       setIsPhoneNumberEmpty(true);
//       openSnackbar("Empty or Invalid Phone Number. Try Again.", "error");
//       return;
//     } else {
//       setIsPhoneNumberEmpty(false);
//     }

//     if (!isPhoneNumberEmpty) {
//       openSnackbar("Sending OTP to Phone Number...", "info", 3000);
//       try {
//         setValidEmail(true);
//         // setIsVisible(true);

//         const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/onboard/send-mobile-otp`, { mobileNumber: phoneNumber },
//           { headers: headers }
//         );
//         // console.log(response.data.message); // Log response message

//         if (response.status === 226) {
//           openSnackbar("User already registered. Please Login.", "info", 8000);
//           setValidEmail(false);
//           return;
//         }
//         else if (response.status === 200) {
//           openSnackbar('OTP sent successfully to the Phone Number.', "success", 8000);
//           const cleanedPhoneNumber = formatPhoneNumber(phoneNumber)
//           setFormData((prevFormData) => ({
//             ...prevFormData,
//             phoneNo: cleanedPhoneNumber,
//           }));
//           setValidEmail(false);
//           setTimeout(() => {
//             setshowSecondScreen(true);
//             setshowfirstScreen(false);
//           }, 1500);

//         }
//       } catch (error) {
//         console.error("Error sending otp:", error);
//         openSnackbar("Failed to send OTP. Check the Phone Number or Try again later.", "error", 8000);
//         setValidEmail(false);
//       }
//     }
//   };

//   const handlesecondClick = async () => {
//     if (phoneNumber === "" || !matchIsValidTel(phoneNumber)) {
//       setIsPhoneNumberEmpty(true);
//       openSnackbar("Empty or Invalid Phone Number. Try Again.", "error");
//       return;
//     }

//     const otp = parseInt(phoneotpValues.join(""));
//     setValidNext(true);

//     try {
//       const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/verify-mobile-otp`,
//         { mobileNumber: phoneNumber, otp: otp },
//         { headers: headers }
//       );
//       // console.log(response.data.message); // Log response message
//       setshowThirdScreen(true);
//       setshowSecondScreen(false);
//       if (typeof setActiveStep === 'function') {
//         setActiveStep();
//       }
//     } catch (error) {
//       console.error("Error verifying otp:", error);
//       setValidNext(false);
//       if (error.response) {
//         const { message } = error.response.data;

//         if (message === "Incorrect OTP") {
//           console.log("Incorrect OTP Response:", error.response);
//           openSnackbar("Incorrect OTP! Please Try Again.", "error");
//           return;
//         }
//         if (message === "Invalid OTP") {
//           console.log("Invalid OTP Response:", error.response);
//           openSnackbar("Invalid OTP! Please Try Again.", "error");
//           return;
//         }
//       } else {
//         console.error('Error verifying email:', error);
//         handleFailure('Error verifying Phone Number. Please try again later.');
//       }
//     }
//   };

//   const handlePhoneChange = (value) => {
//     setValidEmail(false);
//     setPhoneNumber(value);
//     setIsPhoneNumberEmpty(false);
//   };
//   console.log("ACTIVE STEP IN THE Moile verification", activeStep, formData);

//   const handleContinue2 = () => {
//     if (formData?.profession === "Personal") {
//       setActiveStep(5);
//     } else {
//       setActiveStep((prevActiveStep) => prevActiveStep + 1);
//     }

//   };

//   const handleNext = async () => {

//     // if (activeStep !== 1) {
//     //   // setActiveStep();
//     //   setActiveStep((prevActiveStep) => prevActiveStep + 1);

//     // }
//   }

//   const handleCloseVerifiedDialog = () => {
//     setIsVerifiedDialogOpen(false);
//     setVerificationPageVisible(false);
//   };

//   const [value, setValue] = React.useState('')

//   const handleChange = (newValue) => {
//     setValue(newValue)
//   }

//   // Hide the component after 5 seconds
//   useEffect(() => {
//     const timeout = setTimeout(() => {
//       setIsVisible(false);
//     }, 30000);

//     // Clear the timeout when the component unmounts
//     return () => clearTimeout(timeout);
//   }, []);

//   // Determine if the Remaining Time should blink
//   const shouldBlink = seconds < 20 && minutes === 0 && seconds !== 0;
//   const blinkClass = shouldBlink ? "otp-blinking" : "";

//   // Format the time with leading zero if necessary
//   const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
//   const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

//   return (
//     <>
//       {showfirstScreen && (
//         <>
//           <div className="page-title-wrapper">
//             <h2 className="onboard-slide-title-2">Add Phone Number</h2>
//             <p className="sub-title-phone">
//               An OTP will be sent for verification to the entered Phone Number
//             </p>
//           </div>

//           {/* <PhoneInput
//             // onlyCountries={['ind', 'at']}
//             className={isPhoneNumberEmpty ? "phone-input-error" : ""}
//             inputProps={{
//               name: "phone",
//               required: true,
//               autoFocus: true,
//             }}
//             onChange={handlePhoneChange}
//             required
//           /> */}

//           <div className="mx-auto">
//             <MuiTelInput
//               name="phone"
//               value={phoneNumber}
//               onChange={handlePhoneChange}
//               defaultCountry={'in'}
//               MenuProps={PhoneInputMenuProps}
//               required
//               className={` text-field-outline input-text ph-no-input ${isPhoneNumberEmpty ? "phone-input-error" : ""}`}
//               fullWidth
//               error={isPhoneNumberEmpty} />

//             {/* {isPhoneNumberEmpty && (
//               <p className="error-message">Please enter your phone number</p>
//             )} */}

//             <div className="pt-2 next-button-container">
//               <Button
//                 className={`next-btn primary-outlined`}
//                 variant="outlined"
//                 onClick={handlefirstClick}
//                 disabled={(phoneNumber.length <= 3 || phoneNumber.length === 4) || ValidEmail}>
//                 Next
//               </Button>
//             </div>
//           </div>

//           {/* {isVisible && (
//             <InfoToast destination="progress" />
//           )} */}
//         </>
//       )}

//       {showSecondScreen && (
//         <>

//           <React.Fragment>
//             <div className="page-title-wrapper">
//               <h2 className="onboard-slide-title-2">Please Verify your Mobile Number</h2>
//               <p className="sub-title-phone">
//                 Check your device for a verification SMS.
//               </p>
//             </div>

//             <div className="mx-auto">
//               <MuiTelInput
//                 name="phone"
//                 value={phoneNumber}
//                 onChange={handlePhoneChange}
//                 required
//                 className={`text-field-outline input-text ${isPhoneNumberEmpty ? "phone-input-error" : ""}`}
//                 defaultCountry={'in'}
//                 fullWidth
//                 error={isPhoneNumberEmpty} />

//               {/* {[1, 2, 3, 4].map((_, index) => (
//             <input
//               key={`phone-otp-${index}`}
//               type="text"
//               className="pt-50 phone-otp-input"
//               maxLength="1"
//               id={`phone-otp-${index + 1}`}
//               ref={(el) => (phoneOtpInputsRef.current[index] = el)}
//               value={phoneOtpValues[index]}
//               onChange={(e) => handlePhoneOtpInput(index)(e)}
//             />
//           ))} */}
//               <div className="pt-25"></div>

//               <div className="otp-input-wrapper">
//                 {[1, 2, 3, 4].map((_, index) => (
//                   <input
//                     key={index}
//                     type="text"
//                     className="otp-input"
//                     maxLength="1"
//                     id={`otp${index + 1}`}
//                     ref={(el) => (phoneotpInputsRef.current[index] = el)}
//                     value={phoneotpValues[index]}
//                     onChange={handlePhoneInput(index)}
//                     disabled={minutes === 0 && seconds === 0}
//                     onKeyDown={handleKeyDown(index)}
//                     autoFocus={index === 0}
//                   />
//                 ))}
//               </div>




//               {/* <div className="pt-25 next-button-container">
//               <button className={`next-btn ${phoneotpValues.some((value) => !value) ? "disabled" : ""}`}
//                   type="submit"
//                   onClick={handlesecondClick}>
//                 Next
//               </button>
//             </div> */}

//               <div className="justify-content-space-bw-login mt-20">
//                 <div className="resent-otp">
//                   Remaining Time:
//                   <span className={`time-unit ${blinkClass}`}>{formattedMinutes}</span>:
//                   <span className={`time-unit ${blinkClass}`}>{formattedSeconds}</span>
//                 </div>

//                 <div className="next-button-container gap-3 pt-2">
//                   {(
//                     <Button
//                       variant="outlined"
//                       className={`next-btn primary-outlined`}
//                       onClick={handlesecondClick}
//                       disabled={phoneotpValues.some((value) => !value) || ValidNext}>
//                       Next
//                     </Button>
//                   )}
//                 </div>
//               </div>
//               <div className="resent-otp-design mt-20">
//                 Didn't get the code? <Button sx={{ color: "#0044C6" }} onClick={resendOTP}>RESEND</Button>
//               </div>
//             </div>
//           </React.Fragment>
//         </>
//       )}

//       {showThirdScreen && (
//         <>
//           <React.Fragment>
//             <h2 className="onboard-slide-title-2">Please Verify your Mobile Number</h2>
//             <p className="sub-title-phone">
//               Will send you otp to below mentioned Number{" "}
//             </p>


//             <MuiTelInput name="phone" value={phoneNumber} required className={isPhoneNumberEmpty ? "phone-input-error" : ""} defaultCountry={'in'} />


//             <div className="pt-2 next-button-container">
//               <button className="next-btn" type="submit" onClick={handleNext}>
//                 Next
//               </button>
//             </div>
//             <Dialog
//               open={isVerifiedDialogOpen}
//               onClose={handleCloseVerifiedDialog}
//               aria-labelledby="alert-dialog-title"
//               aria-describedby="alert-dialog-description"
//             >
//               <DialogContent className="dialogContainer email-dialog">
//                 <img
//                   src={mobileverify}
//                   alt="Verification"
//                   className="dialogImage"
//                 />
//                 <DialogTitle id="alert-dialog-title">
//                   Mobile Number Verified
//                 </DialogTitle>
//                 <DialogContentText className="dialogText">
//                   Your account is secure! Mobile verification is complete.
//                 </DialogContentText>
//                 <Button
//                   onClick={handleContinue2}
//                   variant="contained"
//                   className="continueButton primary-button"
//                 >
//                   Continue
//                 </Button>
//               </DialogContent>
//             </Dialog>


//           </React.Fragment>
//         </>
//       )}
//     </>
//   );
// };

// export default ActiveStep4;

// // npm install mui-tel-input
// // npm uninstall react-phone-input-2

// export const PhoneInputMenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: "calc(50% - 96px)",
//       marginTop: "20px",
//     }
//   }
// }
